<template>
    <div class="interaction-divider">
        <text-decorator class="interaction-divider-text">
            <slot />
        </text-decorator>
    </div>
</template>

<style scoped lang="scss">
    .interaction-divider {
        display: flex;
        align-items: center;
        text-align: center;
        margin: 16px 0;
    }

    .interaction-divider::before,
    .interaction-divider::after {
        content: '';
        flex: 1;
        border-bottom: 1px solid #ccc;
    }

    .interaction-divider-text {
        padding: 0 12px;
    }
</style>
